module.exports = __webpack_public_path__ + "media/images/icon_link_new-817d5a98.png";